import { jsx as _jsx } from "react/jsx-runtime";
import { Renderer_SearchResult, SearchResult_BaseRightClickActions } from '@app/styles/frontend/ui/components/Renderer_SearchResult/Renderer_SearchResult';
import { isUserPickableExpression } from '@app/hcs-shared';
import { ModuleFE_Expression, Preview_Expression } from '../../_entity.js';
import { UtilObject_Expression } from '../../_entity/expression/util-object.js';
import { QuaiBaseAddOnKeys } from '@app/styles';
import { displayEntityDependencies } from '@app/styles/frontend/ui/consts';
export const SearchItem_Expression = {
    module: ModuleFE_Expression,
    entityLabel: 'Expression',
    globalFilter: expression => isUserPickableExpression(expression),
    compatibleAddOnKeys: [...QuaiBaseAddOnKeys],
    labelResolver: (pointer) => ModuleFE_Expression.cache.unique(pointer.id)?.label ?? 'N/A',
    addOnMethods: {
        getLabel: (pointer) => SearchItem_Expression.labelResolver(pointer).toLowerCase(),
        getSearchTerms: (pointer) => {
            const expression = ModuleFE_Expression.cache.unique(pointer.id);
            return [expression.label.toLowerCase(), pointer.id];
        },
        getEntityKey: (pointer) => pointer.dbKey,
    },
    resultRenderer: (pointer, style) => {
        const expression = ModuleFE_Expression.cache.unique(pointer.id);
        return _jsx(Renderer_SearchResult, { entity: expression, entityLabel: 'Expression', style: style, itemLabel: UtilObject_Expression.renderLabel(expression) ?? 'N/A', subtitle: expression?.expressionType, onClickAction: () => UtilObject_Expression.openEditor(pointer.id), rightClickActions: [
                ...SearchResult_BaseRightClickActions(expression),
                { label: 'Check Usage', action: () => displayEntityDependencies(pointer.dbKey, pointer.id) },
                { label: 'Open Preview', action: () => Preview_Expression.show(pointer.id) }
            ] });
    },
};
//# sourceMappingURL=expression.js.map